<template>
  <CustomModal :closableOnClickOutside="false"
               @close="$emit('close')">
    <template v-slot:body>
      <iframe :src="saltEdgeLink"
              width="400"
              height="600"
              frameborder="0"></iframe>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";

export default {
  name: "SaltEdgeModal",
  props: {
    saltEdgeLink: {
      type: String,
      required: true
    }
  },
  components: {CustomModal}
}
</script>